export default "__VITE_ASSET__A94fHpUd__"